/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleG6Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleG6Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleG6Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleG6Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotG5Placeholder0 = null;

const SlotG5Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG5Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG5Index0Client,
  placeholder: SlotG5Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G5 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G5 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G5, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazyBotPromptG5 = withLayout(

  [

    SlotG5Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G5
  ,

  [

    {
      waitForComponent: SlotG5Index0Client,
      placeholder: SlotG5Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG6Placeholder0K0 = null;

const SlotG6Index0ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/product-overview');
};

export const SlotG6Index0LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
      .ProductOverviewAccordionBody;
  },
  client: SlotG6Index0ClientK0,
  placeholder: SlotG6Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazyProductOverviewAccordionBodyG6 = withLayout(
  SlotG6Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG6Index0ClientK0,
    placeholder: SlotG6Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG6Placeholder1K0 = null;

const SlotG6Index1ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/specifications');
};

export const SlotG6Index1LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
      .SpecificationsAccordionBody;
  },
  client: SlotG6Index1ClientK0,
  placeholder: SlotG6Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsAccordionBody',
});

lazySlots.LazySpecificationsAccordionBodyG6 = withLayout(
  SlotG6Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG6Index1ClientK0,
    placeholder: SlotG6Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG6Placeholder2K0 = null;

const SlotG6Index2ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG6Index2LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotG6Index2ClientK0,
  placeholder: SlotG6Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazyQuestionsAndAnswersAccordionBodyG6 = withLayout(
  SlotG6Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG6Index2ClientK0,
    placeholder: SlotG6Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG6Placeholder3K0 = null;

const SlotG6Index3ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG6Index3LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotG6Index3ClientK0,
  placeholder: SlotG6Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazyRatingsAndReviewsAccordionBodyG6 = withLayout(
  SlotG6Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG6Index3ClientK0,
    placeholder: SlotG6Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazyG6Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleG6Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleG6Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleG6Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleG6Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazyProductOverviewAccordionBodyG6,

    ],

    [

      lazySlots.LazySpecificationsAccordionBodyG6,

    ],

    [

      lazySlots.LazyQuestionsAndAnswersAccordionBodyG6,

    ],

    [

      lazySlots.LazyRatingsAndReviewsAccordionBodyG6,

    ],

  ]
],

null
);

const SlotG7Placeholder0 = null;

const SlotG7Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG7Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG7Index0Client,
  placeholder: SlotG7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G7 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G7 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G7, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazyBotPromptG7 = withLayout(

  [

    SlotG7Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G7
  ,

  [

    {
      waitForComponent: SlotG7Index0Client,
      placeholder: SlotG7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  if (props.slot === 'slotG5') {

    return (
      <lazySlots.LazyBotPromptG5
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG5"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.10.0"
      />
    );

  }

  if (props.slot === 'slotG6') {

    return (
      <LazyG6Accordion
        {...props}
        config={props.config}
        fusionSlotName="slotG6"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'slotG7') {

    return (
      <lazySlots.LazyBotPromptG7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG7"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.10.0"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
